import { v4 as uuidv4 } from "uuid";

import { setAnalyticsUserProperties } from "@/constants/amplitude";
import { GAEvents, sendMetrics } from "@/constants/gtag";
import { sha256Hash } from "@/utils/crypto";
import { localStorageManager, LocalStorageManagerKeys } from "@/utils/localStorageManager";
import { sendMarketingAttractionInfo } from "@/utils/services/api";

const getOrGenerateExternalId = async () => {
    let externalClientId = localStorageManager.getStoredItem<string>(
        LocalStorageManagerKeys.EXTERNAL_ID
    );

    if (!externalClientId) {
        externalClientId = await sha256Hash(uuidv4());
        localStorageManager.storeItem(LocalStorageManagerKeys.EXTERNAL_ID, externalClientId);
    }
    return externalClientId;
};

interface TrackEmailSubmitProps {
    uuid?: string;
    email: string;
}
const trackEmailSubmit = ({ uuid, email }: TrackEmailSubmitProps) => {
    sendMetrics(GAEvents.SignUp, {
        clientId: uuid,
        email,
        event_id: `LTV_${uuid}`,
    });
    setAnalyticsUserProperties({ email });
};

interface TrackMarketingAttractionInfoProps {
    uuid: string | null;
    adParameters: any;
    orderId: string | null | undefined;
}
const trackMarketingAttractionInfo = ({
    uuid,
    adParameters,
    orderId,
}: TrackMarketingAttractionInfoProps) => {
    uuid && sendMarketingAttractionInfo(uuid, adParameters, orderId);
};

export const trackersManager = { trackEmailSubmit, trackMarketingAttractionInfo };
